module.exports = __webpack_public_path__ + "img/pellets-loose.71e41a2.svg";